import "./App.css";
import { HomePage } from "./pages/home/homaPage";
import { Apropos } from "./pages/Apropos/apropos";
import { Mission } from "./pages/Apropos/components/mission";
import { Temoignages } from "./pages/Apropos/components/temoignages";
import Partenaires from "./pages/Apropos/components/gallery.jsx";
import Program from "./pages/gtm_club/2025_program/program";
import Business from "./pages/gtm_club/business/golf&networking/g_n";
import Ranking from "./pages/actualite/ranking/ranking";
import Sponsoring from "./pages/sponsoring/sponsoring";
import ContactUs from "./pages/contactUs/contactUs";

import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import Mainlayout from "./layouts/mainLayout/Mainlayout";
import { Iconic } from "./pages/gtm_club/tournois/iconic";
import { Industry } from "./pages/gtm_club/tournois/IndustryOuting";
import { Daysummit } from "./pages/gtm_club/Strategies Summit/daySummit";
import { Press } from "./pages/actualite/media/press";
import { Blog } from "./pages/actualite/media/blog/blog";
import { Destination } from "./pages/actualite/media/blog/non_classe_DESTINATION";
import { Championship } from "./pages/actualite/media/blog/mo_classe_championship";
import { Discovering } from "./pages/actualite/media/blog/non_classe_discovering";
import { Host } from "./pages/actualite/media/blog/non_classe_host ";
import { Vision } from "./pages/actualite/media/blog/non_classe_vision ";
import G_n from "./pages/gtm_club/business/golf&networking/g_n";
import B_c from "./pages/gtm_club/business/bridgeOfCulture/b_c";
import LoginPage from "./pages/auth/login/loginPage";
import StepOne from "./pages/auth/register/stepOne/stepOne";
import StepTwo from "./pages/auth/register/steptwo/stepTow";
import StepThree from "./pages/auth/register/stepThree/stepThree";
import Verification from "./pages/auth/register/verification/verification";
import Confirmation from "../src/pages/auth/register/confirmation/confirmation";

import Welcome from "./pages/membership/welcome/welcome";
import Demande from "./pages/membership/demande/demande";
import WelcomeTwo from "./pages/membership/welcomeTwo/welcomeTwo";
import Thanks from "./pages/membership/thanks/thanks";
import Felecitation from "./pages/membership/felecitation/felecitation";
import Deals from "./pages/membership/deals/deals";
import Events from "./pages/membership/events/events";
import Show from "./pages/membership/events/showEvent/show";
import { useEffect, useState } from "react";
import axios from "axios";
import { storeCount, storeUser, updateUser } from "./formSlice.js";
import { useDispatch, useSelector } from "react-redux";
import Profile from "./pages/membership/profile/Profile.jsx";
import "./pages/auth/register/confirmation/Confirmation.css";
import images from "./constant/images.jsx";
import ProtectedRoute from "./protectedpaths.jsx";
import EmptyNotif from "./pages/membership/notification/EmptyNotif.jsx";
import { FilledInput } from "@mui/material";
import Paiment from "./pages/membership/paiment/Paiment.jsx";
import ChangePass from "./pages/auth/forgotPass/ChangePass.jsx";
import Forgot_request from "./pages/auth/forgotPass/Forgot_request.jsx";
import NotifPage from "./pages/membership/notification/NotifPage.jsx";
import PaimentInfo from "./pages/membership/paimentInfo/PaimentInfo.jsx";
import ShowNotif from "./pages/membership/notification/ShowNotif.jsx";
import Condition from "./pages/privecy_policy/NotificationCondition.jsx";
import NotificationCondition from "./pages/privecy_policy/NotificationCondition.jsx";
import PaymentConditions from "./pages/privecy_policy/PaymentCondition.jsx";
import ConfidentialitePolitique from "./pages/privecy_policy/ConfidentialitePolitique.jsx";
import TermsConditions from "./pages/privecy_policy/ConditionsAndTerms.jsx";
import NotFoundPage from "./pages/notFound/NotFoundPage.jsx";
import { Bigsmoke } from "./pages/lifeStyle/bigSmoke.jsx";
import { ClassicCars } from "./pages/lifeStyle/classeCars.jsx";
import { Arts } from "./pages/lifeStyle/arts.jsx";
import { MoroccanSun } from "./pages/gtm_club/networking/moroccanSun.jsx";
import { Testimonials } from "./pages/notFound/testimonials/testimonials.jsx";
import { Inittiaition } from "./pages/gtm_club/tournois/inittiaition.jsx";
import Gallery from "./pages/Apropos/components/gallery.jsx";
import { LongDrive } from "./pages/gtm_club/tournois/longsDrive.jsx";
import Members from "./pages/membership/members/Members.jsx";
import ShowMembers from "./pages/membership/members/ShowMembers.jsx";
import MembershipLayout from "./pages/membership/layout/MembershipLayout.jsx";
import ProgramShow from "./pages/gtm_club/2025_program/ProgramShow.jsx";
import EventsCalendar from "./pages/membership/calendar/EventsCalendar.jsx";
import GolfCalendar from "./pages/calendar/calendar.jsx";
import { Conferences } from "./pages/gtm_club/Conference/Conférences .jsx";
import ShowEeventsCalendar from "./pages/calendar/showEventsCalendar.jsx";
import ShowEeventsCalendar2 from "./pages/membership/calendar/ShowEventCalendar.jsx";
// import MembershipRestriction from "./components/MembershipRestriction.jsx";

// import Sidebar from "./layouts/sidebar/sidebar";

// import Events from "./pages/membership/events/events";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false); // To track authentication status
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [pack, setPack] = useState(null);
  const [membership, setMembership] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const sanctum = async () => {
      const response = await axios.get(
        // "http://localhost:8000/sanctum/csrf-cookie",
        "https://gtm.ma/sysgtm/public/sanctum/csrf-cookie",
        {
          withCredentials: true,
          withXSRFToken: true,
        }
      );
    };
    sanctum();

    const checkAuthentication = async () => {
      try {
        const token = localStorage.getItem("userToken");

        if (token) {
          const response = await axios.get(`${baseUrl}/user`, {
            withCredentials: true,
            withXSRFToken: true,
            credentials: "include",

            headers: { Authorization: `Bearer ${token}` },
          });

          if (response.status === 200) {
            setIsAuthenticated(true);
            dispatch(updateUser(response.data));
            setUser(response.data);
            setMembership(response.data.membership);
            if (response.data?.membership?.status.trim() === "valid") {
              setPack(response.data?.membership?.membership_packs?.name);
            }
          } else {
            setIsAuthenticated(false);
          }
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Authentication check failed:", error);
        setIsAuthenticated(false);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    };

    {
      isLoading && (
        <div className="bg-white min-h-screen bg-opacity-[87%] h-full flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] py-8 md:py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
        </div>
      );
    }
    checkAuthentication();
  }, []);

  const getCount = async () => {
    try {
      const response = await axios.get(`${baseUrl}/count`, {
        params: { id: user?.id },
      });
      dispatch(storeCount(response.data.count));
    } catch (error) {}
  };

  if (isAuthenticated) {
    if (user) {
      getCount();
    }
  }
  if (!isLoading) {
  }

  const MembershipRestriction = ({ children }) => {
    const user =
      useSelector((state) => state.gtm.user) ||
      JSON.parse(localStorage.getItem("user"));
    if (user?.membership && user?.membership?.membership_id !== 3) {
      return <Navigate to="/membership/welcome" replace />;
    }
    return children;
  };

  

  const initialRoute = isAuthenticated ? `/membership/welcome` : `/home`;

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Mainlayout />,
      children: [
        {
          index: true,
          element: <Navigate to={initialRoute} replace />,
        },
        {
          path: "/home",
          element: <HomePage />,
        },
        {
          path: "/login",
          element: <LoginPage />,
        },
        {
          path: "/register",
          element: <StepOne />,
        },
        {
          path: "/register/stepTwo",
          element: <StepTwo />,
        },
        {
          path: "/register/stepThree",
          element: <StepThree />,
        },
        {
          path: "/verification",
          element: <Verification />,
        },
        {
          path: "/register/confirmation",
          element: <Confirmation />,
        },
        {
          path: "/apropos",
          element: <Apropos />,
        },
        {
          path: "/apropos/mission",
          element: <Mission />,
        },
        {
          path: "/apropos/temoignage",
          element: <Temoignages />,
        },
        {
          path: "/apropos/partenaire",
          element: <Partenaires />,
        },
        {
          path: "/gtmclub/2025program",
          element: <Program />,
        },
        {
          path: "/gtmclub/2025program/show_events",
          element: <ProgramShow />,
        },
        {
          path: "/gtmclub/tournois/gtmIconic",
          element: <Iconic />,
        },
        {
          path: "/gtmclub/tournois/industry",
          element: <Industry />,
        },
        {
          path: "/gtmclub/tournois/Initiation",
          element: <Inittiaition />,
        },
        {
          path: "/gtmclub/tournois/longsDrive",
          element: <LongDrive />,
        },
        {
          path: "/gtmclub/strategies/2daySummit",
          element: <Daysummit />,
        },

        {
          path: "/gtmclub/Golf&LinkingUp",
          element: <G_n />,
        },
        {
          path: "/gtmclub/calendar",
          element: <GolfCalendar />,
        },
        {
          path: "/gtmclub/calendar/show_events",
          element: <ShowEeventsCalendar />,
        },

        {
          path: "/gtmclub/business/cultures",
          element: <B_c />,
        },
        {
          path: "/actualites/media/presse",
          element: <Press />,
        },
        {
          path: "/actualites/media/blog",
          element: <Blog />,
        },
        {
          path: "/how-much-growth-potential-is-in-morocco-as-a-golf-destination",
          element: <Destination />,
        },
        {
          path: "/golf-frmg-and-cpg-sign-an-agreement-to-support-the-expansion-of-the-golfsixes-leagues-championship-in-morocco",
          element: <Championship />,
        },
        {
          path: "/golf-discovering-the-fantastic-offer-of-morocco",
          element: <Discovering />,
        },
        {
          path: "/morocco-to-host-watc-in-2027",
          element: <Host />,
        },
        {
          path: "/the-vision-of-development-of-golf-in-morocco",
          element: <Vision />,
        },
        {
          path: "/actualites/ranking",
          element: <Ranking />,
        },
        {
          path: "/sponsoring",
          element: <Sponsoring />,
        },

        // {
        //   path: "/membership/welcome",
        //   element: <Welcome />,
        // },

        {
          path: "/membership",
          element: (
            <ProtectedRoute>
              <MembershipLayout />
            </ProtectedRoute>
          ),
          children: [
            {
              index: true,
              element: (
                <ProtectedRoute>
                  <Welcome />
                </ProtectedRoute>
              ),
            },

            {
              path: "/membership/welcome",
              element: (
                <ProtectedRoute>
                  <Welcome />
                </ProtectedRoute>
              ),
            },
            {
              path: "/membership/members",
              element: (
                <MembershipRestriction>
                  <ProtectedRoute>
                    <Members />
                  </ProtectedRoute>
                </MembershipRestriction>
              ),
            },
            {
              path: "/membership/members-details",
              element: (
                <MembershipRestriction>
                  <ProtectedRoute>
                    <ShowMembers />
                  </ProtectedRoute>
                </MembershipRestriction>
              ),
            },
            {
              path: "/membership/welcometwo",
              element: (
                <ProtectedRoute>
                  <WelcomeTwo />
                </ProtectedRoute>
              ),
            },
            {
              path: "/membership/demande",
              element: (
                <ProtectedRoute>
                  <Demande />
                </ProtectedRoute>
              ),
            },
            {
              path: "/membership/thanks",
              element: (
                <ProtectedRoute>
                  <Thanks />
                </ProtectedRoute>
              ),
            },
            {
              path: "/membership/felicitation",
              element: (
                <ProtectedRoute>
                  <Felecitation />
                </ProtectedRoute>
              ),
            },
            {
              path: "/membership/Partners",
              element: (
                <ProtectedRoute>
                  <Deals />
                </ProtectedRoute>
              ),
            },
            {
              path: "/membership/Events",
              element: (
                <ProtectedRoute>
                  <Events />
                </ProtectedRoute>
              ),
            },
            {
              path: "/membership/EventsCalendar",
              element: (
                <ProtectedRoute>
                  <EventsCalendar />
                </ProtectedRoute>
              ),
            },
            {
              path: "/membership/show_events",
              element: <ProtectedRoute><Show /></ProtectedRoute>,
            },
            {
              path: "/membership/profile",
              element: (
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              ),
            },
            {
              path: "/membership/notification",
              element: <ProtectedRoute><NotifPage /></ProtectedRoute>,
            },
            {
              path: "/membership/show-notification",
              element: <ProtectedRoute><ShowNotif /></ProtectedRoute>,
            },
            {
              path: "/membership/paimentInfo",
              element: <ProtectedRoute><PaimentInfo /></ProtectedRoute>,
            },
            {
              path: "/membership/paiments",
              element: <ProtectedRoute><Paiment /></ProtectedRoute>,
            },
            {
              path: "/membership/paimentInfo",
              element: <ProtectedRoute><PaimentInfo /></ProtectedRoute>,
            },
            {
              path: "/membership/Testimonials",
              element: <ProtectedRoute><Testimonials /></ProtectedRoute>,
            },
            {
              path: "/membership/Contact",
              element: <ProtectedRoute><ContactUs /></ProtectedRoute>,
            },
            {
              path: "/membership/calendar/show_events",
              element: <ProtectedRoute><ShowEeventsCalendar2 /></ProtectedRoute>,
            },
          ],
        },
        {
          path: "/request_change_password",
          element: <Forgot_request />,
        },
        {
          path: "/change_password",
          element: <ChangePass />,
        },

        {
          path: "/conditions-de-notification",
          element: <NotificationCondition />,
        },
        {
          path: "/conditions-de-paiement",
          element: <PaymentConditions />,
        },
        {
          path: "/politique-de-confidentialite",
          element: <ConfidentialitePolitique />,
        },
        {
          path: "/termes-et-conditions",
          element: <TermsConditions />,
        },
        {
          path: "/lifestyle/bigsmoke",
          element: <Bigsmoke />,
        },
        {
          path: "/lifestyle/classicCars",
          element: <ClassicCars />,
        },
        {
          path: "/lifestyle/arts",
          element: <Arts />,
        },
        {
          path: "/networking/moroccanSun",
          element: <MoroccanSun />,
        },
        {
          path: "/networking/conference",
          element: <Conferences />,
        },

        {
          path: "/apropos/gallery",
          element: <Gallery />,
        },

        {
          path: "/*",
          element: <NotFoundPage />,
        },
      ],
    },
  ]);

  // if (isLoading) {
  //   return (
  //     <div
  //       className=" h-[100vh] flex justify-center items-center"
  //       style={{
  //         backgroundImage: `url(${images.golf_field})`,
  //         backgroundPosition: "center",
  //         backgroundSize: "cover",
  //         backgroundRepeat: "no-repeat",
  //       }}
  //     >
  //       {/* <p className="loaderText">Loading...</p> */}
  //       <div className="spinner"></div>
  //     </div>
  //   );
  // } else {
  // }
  return <RouterProvider router={router} />;
}

export default App;
